import { render, staticRenderFns } from "./OrgStatisticSection.vue?vue&type=template&id=ef9ebaac&"
import script from "./OrgStatisticSection.vue?vue&type=script&lang=js&"
export * from "./OrgStatisticSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports